
(function($) {
  'use strict';

  var STORAGE_KEY = 'moko_tab_states_v1';
  var MAX_STATES = 30;

  function normalizeStates(states) {
    var result = {};
    if (!states || typeof states !== 'object') {
      return result;
    }

    Object.keys(states).forEach(function(groupId) {
      var state = states[groupId];
      if (!state || typeof state !== 'object') {
        return;
      }
      if (!state.tab || !state.updated_at) {
        return;
      }
      result[groupId] = {
        tab: String(state.tab),
        updated_at: Number(state.updated_at) || 0
      };
    });

    return result;
  }

  function getStates() {
    if (!window.localStorage) {
      return {};
    }

    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var states = raw ? JSON.parse(raw) : {};
      return normalizeStates(states);
    } catch (ex) {
      return {};
    }
  }

  function setStates(states) {
    if (!window.localStorage) {
      return;
    }

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalizeStates(states)));
    } catch (ex) {
      // localStorage 容量制限などは無視
    }
  }

  function saveActiveTab(groupId, tabId) {
    if (!groupId || !tabId) {
      return;
    }

    var states = getStates();
    states[groupId] = {
      tab: tabId,
      updated_at: Date.now()
    };

    var entries = Object.keys(states);
    if (entries.length > MAX_STATES) {
      entries.sort(function(a, b) {
        return (states[b].updated_at || 0) - (states[a].updated_at || 0);
      });
      var next = {};
      for (var i = 0; i < MAX_STATES; i++) {
        var key = entries[i];
        if (states[key]) {
          next[key] = states[key];
        }
      }
      states = next;
    }

    setStates(states);
  }

  function restoreActiveTab($group, states) {
    var groupId = $group.attr('id');
    if (!groupId) {
      return;
    }

    var saved = states[groupId];
    if (!saved || !saved.tab) {
      return;
    }

    var $savedTab = $group.find('[data-toggle="tab"][aria-controls="' + saved.tab + '"]');
    if (!$savedTab.length) {
      $savedTab = $group.find('[data-toggle="tab"][href="#' + saved.tab + '"]');
    }
    if (!$savedTab.length || $savedTab.hasClass('disabled')) {
      return;
    }

    if (!$.isFunction($savedTab.tab)) {
      restoreByClass($group, $savedTab);
      return;
    }

    $savedTab.tab('show');
  }

  function restoreByClass($group, $target) {
    var href = $target.attr('href');
    if (!href) {
      return;
    }

    var $pane = $(href);
    if (!$pane.length) {
      return;
    }

    $group.find('[data-toggle="tab"]').removeClass('disabled');
    $target.addClass('disabled');

    var $tabContent = $group.find('.tab-content');
    if ($tabContent.length) {
      $tabContent.children('.tab-pane').removeClass('active');
      $pane.addClass('active');
    }
  }

  $(document).on('shown.bs.tab', '[data-remember="true"] [data-toggle="tab"]', function (e) {
    var $target = $(e.target);
    var showControl = $target.attr('aria-controls') || '';
    var groupId = $target.closest('[data-remember="true"]').attr('id');
    if (!groupId || !showControl) {
      return;
    }
    saveActiveTab(groupId, showControl);
  });

  $(function() {
    var states = getStates();
    $('[data-remember="true"][id]').each(function () {
      restoreActiveTab($(this), states);
    });
  });

})(jQuery);
